module.exports = __webpack_public_path__ + "img/004.1ee7c51c.png";